import { Loading } from 'components/loading'
import * as React from 'react'
import { EmailTemplates } from 'shared_server_client/constants'
import { ArticleImageUrlInput } from './article-image-url-input'
import { Font, IMAGE_MAY_BE_TOO_SMALL_TEMPLATE_TOOLTIP, IMAGE_TOO_SMALL_TOOLTIP } from './constants'
import { imageIsTooSmall } from './utility/utils'
import { ImageSelectorModal } from '../common/image-selector/modal'
import { FrameLandscapeIcon } from 'components/icons/frame-landscape'
import './article-image-upload.scss'

interface ArticleImageUploadProps {
  allowAIGeneration?: boolean,
  allowUseUrl?: boolean,
  allowImageLibrary?: boolean,
  imageHeight: number,
  imageUrl: string,
  imageWidth: number,
  isUploading: boolean,
  uploadImage: any,
  clearImage: any,
  font?: Font,
  updateImageUrl?: any,
  useUrlClick?: any,
  aiGenerateImageClick?: (preferences?: any) => void
  selectImageLibrary?: any
  openImageGalleryModal?: any,
  saveToGallery?: boolean,
  articleTitle?: string,
  articleDescription?: string,
  userPreferences?: any
}

interface ArticleImageUploadState {
  errorMessage: string,
  imageUrl: string,
  isUploading: boolean,
  showUrlInput: boolean,
  validUrl: boolean,
  showImageSelectorModal: boolean,
}
export class ArticleImageUpload extends React.Component<ArticleImageUploadProps, ArticleImageUploadState> {
  public fileInputRef;
  constructor(props: any) {
    super(props)
    this.state = {
      errorMessage: '',
      imageUrl: '',
      isUploading: false,
      showUrlInput: false,
      validUrl: false,
      showImageSelectorModal: false,
    }
    this.fileInputRef = React.createRef()
  }
  public render() {
    return this.props.isUploading ?
      <div>
        <Loading size="64"/>
      </div>
    :
    <div className="upload-section">
      <div className="upload-label">
        <div className="image-container-wrapper" style={{position: 'relative', display: 'inline-block'}}>
          {
            this.props.imageUrl
              ? (
                  <div className="image-with-overlay" style={{position: 'relative'}}>
                    <img 
                      src={this.props.imageUrl} 
                      style={{
                        maxWidth: this.props.font === Font.LARGE ? 400 : 100,
                        maxHeight: this.props.font === Font.LARGE ? 250 : 100,
                        display: 'block'
                      }}
                    />
                    <div className="image-overlay-icons">
                      <div 
                        className="overlay-icon edit-icon" 
                        onClick={this.openImageSelectorModal}
                        title="Change Image"
                      >
                        <i className="fas fa-camera" style={{fontSize: '16px', color: 'white'}} />
                      </div>
                      <div 
                        className="overlay-icon delete-icon" 
                        onClick={this.props.clearImage}
                        title="Remove Image"
                      >
                        <i className="fas fa-trash" style={{fontSize: '16px', color: 'white'}} />
                      </div>
                    </div>
                  </div>
                )
              : (
                  <div className="placeholder-with-overlay" style={{position: 'relative'}}>
                    <div 
                      className="placeholder-icon-container" 
                      onClick={this.openImageSelectorModal}
                      style={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: this.props.font === Font.LARGE ? 400 : 100,
                        height: this.props.font === Font.LARGE ? 250 : 100,
                        backgroundColor: '#f8f9fa',
                        border: '2px dashed #dee2e6',
                        borderRadius: '4px'
                      }}
                    >
                      <FrameLandscapeIcon 
                        svgWidth={this.props.font === Font.LARGE ? 60 : 30} 
                        svgHeight={this.props.font === Font.LARGE ? 60 : 30} 
                      />
                    </div>
                    <div className="placeholder-overlay-icon">
                      <div 
                        className="overlay-icon edit-icon" 
                        onClick={this.openImageSelectorModal}
                        title="Select Image"
                      >
                        <i className="fas fa-camera" style={{fontSize: '16px', color: 'white'}} />
                      </div>
                    </div>
                  </div>
                )
          }
        </div>
      </div>
      {this.state.showUrlInput && !this.props.imageUrl &&
        <ArticleImageUrlInput isUploading={this.props.isUploading}
          cancelUpload={this.cancelUpload} updateImageUrl={this.updateImageUrl} />
      }
      <input type="file"
            className="hidden"
            onChange={(e) => this.props.uploadImage(e.target.files[0])}
            ref={this.fileInputRef}
            id="image"
            name="image"
            accept="image/png, image/jpeg">
      </input>
      {this.props.imageUrl ? imageIsTooSmall(this.props.imageHeight, this.props.imageWidth, EmailTemplates.bigAndBold) ?
        <div className={`${this.props.font} image-too-small`}>
          {IMAGE_MAY_BE_TOO_SMALL_TEMPLATE_TOOLTIP}
        </div>
      : imageIsTooSmall(this.props.imageHeight, this.props.imageWidth, EmailTemplates.default) ?
        <div className={`${this.props.font} image-too-small`}>
          {IMAGE_TOO_SMALL_TOOLTIP}
        </div>
      : <div></div> : null}
      
      {this.state.showImageSelectorModal && (
        <ImageSelectorModal
          data={this.state.showImageSelectorModal ? {} : null}
          closeModal={this.closeImageSelectorModal}
          onSelectImage={this.handleImageSelection}
          saveToGallery={this.props.saveToGallery}
          allowAIGeneration={this.props.allowAIGeneration}
          allowUpload={true}
          allowURL={this.props.allowUseUrl}
          allowGallery={this.props.allowImageLibrary}
          articleTitle={this.props.articleTitle}
          articleDescription={this.props.articleDescription}
          userPreferences={this.props.userPreferences}
          aiGenerateImageClick={this.props.aiGenerateImageClick}
          uploadImage={this.props.uploadImage}
          closeButtonText="Cancel"
          size="lg"
        />
      )}
    </div>
  }


  private openImageSelectorModal = () => {
    this.setState({ showImageSelectorModal: true })
  }

  private closeImageSelectorModal = (key: string) => {
    this.setState({ showImageSelectorModal: false })
  }

  private handleImageSelection = (selectedImage: { url: string; imageWidth: number; imageHeight: number }) => {
    if (this.props.updateImageUrl) {
      this.props.updateImageUrl(selectedImage)
    }
    this.setState({ showImageSelectorModal: false })
  }

  private updateImageUrl = (imageUrl: string) => {
    this.setState({
      showUrlInput: false,
    })
    this.props.updateImageUrl(imageUrl)
  }

  private cancelUpload = () => {
    this.setState({
      showUrlInput: false,
    })
  }
}
